import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function AccessOfferCard({
  offer,
  active,
  isPrimary = false,
  disabled = false,
  onPurchase,
  dataPrefix,
}) {
  return (
    <section
      className={cn(
        "lumen-card access-offer-card",
        isPrimary ? "value-major access-offer-card--primary" : "value-fragment access-offer-card--secondary",
        active && "access-offer-card--active",
      )}
      data-testid={`${dataPrefix}-card`}
    >
      <div className="access-offer-shell">
        <div className="space-y-4">
          <div className="lumen-panel-topline" data-testid={`${dataPrefix}-topline`}>
            <p className="lumen-panel-kicker" data-testid={`${dataPrefix}-kicker`}>
              {offer.tier === "cycle" ? "Seuil principal" : "Corpus vivant"}
            </p>
            <span className="lumen-plus">+</span>
          </div>

          <div className="access-offer-heading" data-testid={`${dataPrefix}-heading`}>
            <h2 className="lumen-card-title text-3xl" data-testid={`${dataPrefix}-title`}>
              {offer.title}
            </h2>
            <p className="access-offer-price" data-testid={`${dataPrefix}-price`}>
              {offer.price_label}
            </p>
          </div>

          <p className="lumen-copy access-offer-summary" data-testid={`${dataPrefix}-summary`}>
            {offer.summary}
          </p>
        </div>

        <div className="space-y-5">
          <div className="access-offer-included" data-testid={`${dataPrefix}-included`}>
            {offer.included.map((item, index) => (
              <div className="access-offer-included-row" key={item} data-testid={`${dataPrefix}-included-${index + 1}`}>
                <Check className="h-4 w-4 text-[var(--lumen-gold)]" />
                <span>{item}</span>
              </div>
            ))}
          </div>

          {active ? (
            <div className="access-offer-active" data-testid={`${dataPrefix}-active`}>
              Accès actif
            </div>
          ) : (
            <Button
              className={isPrimary ? "lumen-gold-button w-full" : "lumen-outline-button w-full"}
              data-testid={`${dataPrefix}-purchase-button`}
              disabled={disabled}
              onClick={() => onPurchase(offer.id)}
              type="button"
              variant={isPrimary ? "default" : "outline"}
            >
              {offer.tier === "cycle" ? "Entrer par ce seuil" : "Franchir le corpus vivant"}
              <ArrowRight />
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}